const menuData = [
  {
    id: 1,
    title: "Home",
    path: "/",
    type: "page",
  },
  {
    id: 2,
    title: "GDGoC",
    path: "/#what-is-gdgc",
  },
  {
    id: 3,
    title: "Takeaways",
    path: "/#takeaways",
  },
  {
    id:4,
    title: "Sponsors",
    path:"/#sponsors",
  },
  {
    id: 5,
    title: "Verify Certificate",
    path: "/certificates",
    type:"page",
  },
  // {
  //   id: 6,
  //   title: "Team",
  //   path: "/team",
  //   type: "page",
  // },
];

export default menuData;
